import axios from 'axios'
import { ALTERAR_EMPRESA } from '../types'
import { URL } from '../../util/ambienteActions';
import {SLOW_REQUEST_HEADER} from '../../util/loadingUtil';

export default function alterarEmpresa (empresa) {
  const url = `${URL}/empresas/alterar`;

  return dispatch => axios.post(url, empresa, { headers: { 'Content-Type': 'multipart/mixed', [SLOW_REQUEST_HEADER]: true } }).then(
      response => dispatch({
        type: ALTERAR_EMPRESA,
        payload: response
      })
  );
}
